import { FormControl, FormHelperText, InputLabel, MenuItem, Select } from '@mui/material';
import { ButtonForm, CustomTextField } from 'Components/Form/styles';
import { Column, Row } from 'Components/Grid';
import { Controller } from 'react-hook-form';
import { useQuery } from 'react-query';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { getAreasShort } from 'services/areas-service';
import { getProcessesShort } from 'services/processes-service';

export const GenerateNewReportRopa = ({
  handleComplete,
  register,
  control,
  handleSubmit,
  getValues,
  errors,
  watch,
  selectedTenant,
}) => {
  const { t } = useTranslation('mapping');
  let scope = watch('scope');
  const SCOPE_OPTIONS = [
    { value: 'Empresa', label: t('ropa.reportForm.scopes.company') },
    { value: 'Área', label: t('ropa.reportForm.scopes.area') },
    { value: 'Processo', label: t('ropa.reportForm.scopes.process') },
    { value: 'Sumário Executivo', label: t('ropa.reportForm.scopes.executiveSummary') },
  ];
  const { data: areas } = useQuery(['getAreas', scope], async () => {
    if (selectedTenant.slug === undefined || scope === 'Empresa' || scope === 'Processo') return [];
    const result = await getAreasShort(selectedTenant.slug);
    return result?.data.length > 0 ? result?.data : [];
  });
  const { data: processes } = useQuery(['getProcesses', scope], async () => {
    if (selectedTenant.slug === undefined || scope === 'Empresa' || scope === 'Area') return [];
    const result = await getProcessesShort(selectedTenant.slug);
    return result?.data.length > 0 ? result?.data : [];
  });
  const navigate = useNavigate();
  const onSubmit = () => {
    handleComplete();
  };

  return (
    <form onSubmit={handleSubmit(onSubmit)}>
      <Row justifyContent="center">
        <Column xs={12} sm={6} md={6} className="d-flex">
          <CustomTextField
            {...register('name', { required: t('ropa.reportForm.nameRequired') })}
            label={t('ropa.reportForm.reportName')}
            autoFocus
            error={errors?.name ? true : false}
            sx={{ minHeight: '48px', margin: '0 auto 24px', width: '100%' }}
            helperText={errors?.name ? errors.name.message : null}
            InputLabelProps={{ shrink: true }}
            data-tour="report-name"
          />
        </Column>
        <Column xs={12} sm={6} md={6} className="d-flex">
          <Controller
            control={control}
            rules={{
              validate: () => {
                return getValues('scope') !== '';
              },
              required: t('ropa.reportForm.scopeRequired'),
            }}
            name="scope"
            render={({ field: { onChange, value } }) => (
              <FormControl fullWidth sx={{ marginBottom: '24px', maxHeight: '52px' }} error={errors?.scope ? true : false} data-tour="report-scope">
                <InputLabel id="scope-label" shrink={true}>
                  {t('ropa.reportForm.scope')}
                </InputLabel>
                <Select labelId="scope-label" id="scope" value={value} notched label={t('ropa.reportForm.scope')} onChange={onChange}>
                  <MenuItem value="" key={-1}>
                    {t('ropa.reportForm.selectScope')}
                  </MenuItem>
                  {SCOPE_OPTIONS.map((item, index) => (
                    <MenuItem value={item.value} key={index}>
                      {item.label}
                    </MenuItem>
                  ))}
                </Select>
                <FormHelperText>{errors?.scope ? errors.scope.message : ''}</FormHelperText>
              </FormControl>
            )}
          />
        </Column>
        <Column xs={12} sm={6} md={6} className="d-flex">
          {scope === 'Área' && !!areas && areas.length > 0 && (
            <Controller
              control={control}
              name="areaId"
              render={({ field: { onChange, value } }) => (
                <FormControl fullWidth sx={{ marginBottom: '24px' }}>
                  <InputLabel id="areaId-label" shrink={true}>
                    {t('ropa.reportForm.area')}
                  </InputLabel>
                  <Select labelId="areaId-label" id="areaId" value={value} notched label={t('ropa.reportForm.area')} onChange={onChange}>
                    <MenuItem value="" key={-1}>
                      {t('ropa.reportForm.selectArea')}
                    </MenuItem>
                    {areas.map((item, index) => (
                      <MenuItem
                        sx={{
                          display: item?.archived ? 'none' : '',
                        }}
                        value={item._id}
                        key={index}
                      >
                        {item.name}
                      </MenuItem>
                    ))}
                  </Select>
                </FormControl>
              )}
            />
          )}
          {scope === 'Processo' && !!processes && processes.length > 0 && (
            <Controller
              control={control}
              name="processId"
              render={({ field: { onChange, value } }) => (
                <FormControl fullWidth sx={{ marginBottom: '24px' }}>
                  <InputLabel id="processId-label" shrink={true}>
                    {t('ropa.reportForm.process')}
                  </InputLabel>
                  <Select
                    labelId="processId-label"
                    id="processId"
                    value={value}
                    notched
                    label={t('ropa.reportForm.process')}
                    onChange={onChange}
                  >
                    <MenuItem value="" key={-1}>
                      {t('ropa.reportForm.selectProcess')}
                    </MenuItem>
                    {processes.map((item, index) => (
                      <MenuItem
                        sx={{
                          display: item?.archived ? 'none' : '',
                        }}
                        value={item._id}
                        key={index}
                      >
                        {item.name}
                      </MenuItem>
                    ))}
                  </Select>
                </FormControl>
              )}
            />
          )}
        </Column>
      </Row>
      <Row justifyContent="end" alignItems="center">
        <Column xs={4} md={3} className="d-flex" style={{ gap: '8px', justifyContent: 'flex-end' }}>
          <div data-tour="form-actions" style={{ display: 'flex', gap: '8px' }}>
            <ButtonForm secondary id="cancel" label={t('ropa.reportForm.cancel')} onClick={() => navigate('/reports/ropa')}></ButtonForm>
            <ButtonForm label={t('ropa.reportForm.save')} type="submit" />
          </div>
        </Column>
      </Row>
    </form>
  );
};
